var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarHalfFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55431_29874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4885 13.9684C9.18503 13.7985 8.81509 13.7985 8.51161 13.9684L5.60201 15.5971C4.85742 16.0139 3.96646 15.3666 4.13274 14.5296L4.78248 11.259C4.85025 10.9179 4.73592 10.5661 4.48057 10.33L2.03211 8.06592C1.40558 7.48657 1.74586 6.43916 2.59325 6.33866L5.90475 5.94592C6.25008 5.90496 6.54934 5.68754 6.69501 5.37176L8.09202 2.3434C8.44945 1.56858 9.55067 1.56858 9.9081 2.3434L11.3051 5.37176C11.4508 5.68754 11.75 5.90496 12.0954 5.94592L15.4069 6.33866C16.2543 6.43916 16.5945 7.48657 15.968 8.06592L13.5195 10.33C13.2642 10.5661 13.1499 10.9179 13.2176 11.259L13.8674 14.5296C14.0337 15.3666 13.1427 16.0139 12.3981 15.5971L9.4885 13.9684Z",
    fill: "#DFE6E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_55431_29874)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_55431_29874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4885 13.9684C9.18503 13.7985 8.81509 13.7985 8.51161 13.9684L5.60201 15.5971C4.85742 16.0139 3.96646 15.3666 4.13274 14.5296L4.78248 11.259C4.85025 10.9179 4.73592 10.5661 4.48057 10.33L2.03211 8.06592C1.40558 7.48657 1.74586 6.43916 2.59325 6.33866L5.90475 5.94592C6.25008 5.90496 6.54934 5.68754 6.69501 5.37176L8.09202 2.3434C8.44945 1.56858 9.55067 1.56858 9.9081 2.3434L11.3051 5.37176C11.4508 5.68754 11.75 5.90496 12.0954 5.94592L15.4069 6.33866C16.2543 6.43916 16.5945 7.48657 15.968 8.06592L13.5195 10.33C13.2642 10.5661 13.1499 10.9179 13.2176 11.259L13.8674 14.5296C14.0337 15.3666 13.1427 16.0139 12.3981 15.5971L9.4885 13.9684Z",
    fill: "#FFC700"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55431_29874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_55431_29874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_55431_29874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalfFill);
export default __webpack_public_path__ + "static/media/star-half-fill.9711f41ea75b39da62e072835ce78fa9.svg";
export { ForwardRef as ReactComponent };